import React from "react";

type PageTitleProps = {
  text: string;
  children?: React.ReactNode;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  className?: string;
  props?: any;
  icon?: React.ReactNode;
};

import { PageTitleContainer } from "./styles"

const PageTitle = ({
  text,
  children,
  variant = "h1",
  className,
  props,
  icon
}: PageTitleProps) => {
  const Component = variant;

  return (
    <PageTitleContainer>
      <Component className={`${className || ""}`} {...props}>
        {icon && (
          <span className="page-title-icon">{icon}</span>
        )}
        {text}
        {children && <span>{children}</span>}
      </Component>
    </PageTitleContainer>
  );
};

export default PageTitle;